import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import Slider from '../../js/modules/Slider.mjs';
import {deviceIsMinMd} from '../../js/utilities/media-queries.mjs';

const $collectionSocialMedia = $('.ef-collection-social-media__social-content');
const $collectionSocialMediaWrapper = $('.ef-collection-social-media__social-content__wrapper', $collectionSocialMedia);
const $collectionSocialMediaSlide = $('.ef-collection-social-media__social-content__item', $collectionSocialMediaWrapper);
const $images = $collectionSocialMedia.find('.ef-collection-social-media__social-content__item-medium');
const $firstImage = $images.first();
const socialFeedElem = document.querySelector('.ef-collection-social-media__social-content__wrapper');
let iso = null;
let SliderCollectionSocialMedia;

$collectionSocialMedia.each(function() {
  handleViewportSwitch(deviceIsMinMd);
  deviceIsMinMd.addListener(handleViewportSwitch);
});

/**
 * @param {MediaQueryList} deviceIsMinMdMql
 */
function handleViewportSwitch(deviceIsMinMdMql) {
  if (deviceIsMinMdMql.matches) {
    // >medium
    if (SliderCollectionSocialMedia) {
      SliderCollectionSocialMedia.destroy();
    }

    $collectionSocialMedia.removeClass('swiper-container');
    $collectionSocialMediaWrapper.removeClass('swiper-wrapper');
    $collectionSocialMediaSlide.removeClass('swiper-slide');

    initIsotop();
  } else {
    if (iso) {
      iso.destroy();
    }
    // <medium

    $collectionSocialMedia.addClass('swiper-container');
    $collectionSocialMediaWrapper.addClass('swiper-wrapper');
    $collectionSocialMediaSlide.addClass('swiper-slide');

    $collectionSocialMedia.each((index, slider) => {
      SliderCollectionSocialMedia = new Slider({
        namespace: 'CollectionSocialMedia',
        sliderNode: slider,
        swiperConfigOverride: {
          autoHeight: true,
          preloadImages: false,
        }
      });

      SliderCollectionSocialMedia.init();
      $firstImage.on('load', () => {
        SliderCollectionSocialMedia.slider.swiper.updateAutoHeight();
      });
    });
  }
}

/*
 * Legacy code
 */
function initIsotop() {
  iso = new Isotope(socialFeedElem, {
    itemSelector: '.ef-collection-social-media__social-content__item',
    percentPosition: true,
    masonry: {
      columnWidth: '.ef-collection-social-media__social-content__item',
    },
  });

  imagesLoaded(socialFeedElem).on('progress', function() {
    // layout Isotope after each image loads
    // EFA-1843 call layout() with timeout to avoid issues with delayed rendering
    setTimeout(function() {
      iso.layout();
    }, 500);
  });
}
